angular.module('rjmNg.api').factory("Dashboard", [
  "$resource"
  "phpServiceUrl"
  ($resource, phpServiceUrl) ->
    Dashboard = $resource(phpServiceUrl("/client/:clientId/dashboard/:id"))
    Dashboard::destroy = (cb) ->
      Dashboard.delete { id: @id, clientId: @clientId }, cb

    return Dashboard
  ]
)
